import React from "react";
import logoImage from "../../assets/logo.png";

export const CustomerAnalyticsLogo = ({ shouldStyleChange = false }: { shouldStyleChange?: boolean }) => {
    return (
        <div
            className={`${
                shouldStyleChange ? "absolute top-[20px] left-[43%]" : ""
            } flex items-center gap-2 bg-transparent p-0`}>
            <div className="flex items-center justify-center">
                <img className="w-[228px] h-[40px]" src={logoImage} />
            </div>
        </div>
    );
};
